export default __webpack_public_path__ + "static/media/Planets - Hero.94d26ccb.png";